// extracted by mini-css-extract-plugin
export var dividerLine = "_68-0";
export var errorBackground = "_68-1";